import {
	permissionList,
	hasPermissions,
	attachmentPermissionSet,
	viewBoardingPagePermissionSet,
} from "helpers";

export const boardingApplicationTabs = [
	{
		to: "details",
		eventKey: "details",
		label: "Boarding Details",
		requiredPermissions: viewBoardingPagePermissionSet,
	},
	{
		to: "achProcessor",
		eventKey: "achProcessor",
		label: "ACH Processor",
		requiredPermissions: viewBoardingPagePermissionSet,
	},
	{
		to: "deal-notes",
		eventKey: "deal-notes",
		label: "Deal Notes",
		requiredPermissions: permissionList.ViewAccountNotes,
	},
	{
		to: "pend-details",
		eventKey: "pend-details",
		label: "Pend Details",
		requiredPermissions: viewBoardingPagePermissionSet,
	},
	{
		to: "attachments",
		eventKey: "attachments",
		label: "Attachments",
		requiredPermissions: attachmentPermissionSet,
	},
];

export const getBoardingQueuePaths = () =>
	boardingApplicationTabs
		.filter(tab => hasPermissions(tab.requiredPermissions))
		.map(tab => tab.to);
